import { Component, type ErrorInfo, type ReactNode } from 'react';
import type { ErrorReporter } from '../lib/ports';
import { t } from '../messages/vi';

interface Props {
  /** Passed in (not read from context) because the boundary sits above `PortsProvider`. */
  reporter: ErrorReporter;
  children: ReactNode;
}

interface State {
  failed: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo) {
    this.props.reporter.report(error, {
      source: 'error-boundary',
      componentStack: info.componentStack,
    });
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert">
        <p>{t('error.generic')}</p>
        <button type="button" onClick={() => window.location.reload()}>
          {t('error.reload')}
        </button>
      </div>
    );
  }
}
